export default "__VITE_ASSET__830b322f__"